<div>
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">{{ data?.titleMessage }}</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
  </div>
  
  <div class="modal-body text-grey">
    <p style="line-break: anywhere;" [innerHTML]="getFormattedMessage(data?.bodyMessage)"></p>
    <!--This option is enabled by default to only remove the node from database without deleting the actual cloud resource.-->
    <div *ngIf="data.titleMessage == 'Delete Workstation'" style="margin-top: 15px;">
      <mat-checkbox [(ngModel)]="skipCloudDeployment" [checked]="true">
        {{ skipMessage }}
      </mat-checkbox>
    </div>
  </div>

  <div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="onClose()">{{ data?.cancelText }}</button>
		<button type="button" class="btn btn-primary" (click)="onSubmit()">
			{{ data?.submitText }}
		</button>
	</div>
</div> 
